import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link, Navigate } from "react-router-dom"
import { isEmpty } from "lodash"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"

//import components
import DeleteModal from "../../components/Common/DeleteModal"
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"

import {
  getOrders as onGetOrders,
  addNewOrder as onAddNewOrder,
  updateOrder as onUpdateOrder,
  deleteOrder as onDeleteOrder,
} from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import {
  Button,
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Badge,
  FormGroup,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import Spinners from "components/Common/Spinner"
import { ToastContainer } from "react-toastify"
import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
function CMSList() {
  //meta title
  document.title = "Inventya"
  const navigate = useNavigate()
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [registrationData, setRegistrationData] = useState([])
  const [order, setOrder] = useState(null)

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: (order && order.orderId) || "",
      billingName: (order && order.billingName) || "",
      orderDate: (order && order.orderDate) || "",
      total: (order && order.total) || "",
      paymentStatus: (order && order.paymentStatus) || "Paid",
      badgeClass: (order && order.badgeClass) || "success",
      paymentMethod: (order && order.paymentMethod) || "Mastercard",
    },
    validationSchema: Yup.object({
      orderId: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, "Please Enter Valid Order Id")
        .required("Please Enter Your Order Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderDate: Yup.string().required("Please Enter Your Order Date"),
      total: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, "Please Enter Valid Amount")
        .required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeClass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateOrder = {
          id: order ? order.id : 0,
          orderId: values.orderId,
          billingName: values.billingName,
          orderDate: values.orderDate,
          total: values.total,
          paymentStatus: values.paymentStatus,
          paymentMethod: values.paymentMethod,
          badgeClass: values.badgeClass,
        }
        // update order
        dispatch(onUpdateOrder(updateOrder))
        validation.resetForm()
      } else {
        const newOrder = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          orderId: values["orderId"],
          billingName: values["billingName"],
          orderDate: values["orderDate"],
          total: values["total"],
          paymentStatus: values["paymentStatus"],
          paymentMethod: values["paymentMethod"],
          badgeClass: values["badgeClass"],
        }
        // save new order
        dispatch(onAddNewOrder(newOrder))
        validation.resetForm()
      }
      toggle()
    },
  })

  const toggleViewModal = () => setModal1(!modal1)

  const dispatch = useDispatch()

  const EcommerenceOrderProperties = createSelector(
    state => state.ecommerce,
    Ecommerce => ({
      orders: Ecommerce.orders,
      loading: Ecommerce.loading,
    })
  )

  const { orders, loading } = useSelector(EcommerenceOrderProperties)

  const [isLoading, setLoading] = useState(loading)
  const getRegistration = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.getCMSList()
      setRegistrationData(data.results)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    } finally {
      setLoading(false)
    }
  }
  useEffect(() => {
    getRegistration()
  }, [])

  useEffect(() => {
    if (!isEmpty(orders) && !!isEdit) {
      setIsEdit(false)
    }
  }, [orders])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setOrder(null)
    } else {
      setModal(true)
    }
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const handleOrderClicks = () => {
    setIsEdit(false)
    setOrder("")
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        header: "S.No.",
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Page Title",
        accessorKey: "name",
        enableColumnFilter: false,
        enableSorting: true,
      },

      {
        header: "Edit",
        enableColumnFilter: false,
        enableSorting: true,
        accessorKey: "view",
        cell: cell => {
          return (
            <Button
              type="button"
              color="primary"
              className="btn-sm btn-rounded"
              onClick={() => navigate(`/cms-list/${cell.row.original.id}`)}
            >
              Edit
            </Button>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Row>
            <Col xs={12}>
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-sm-0 font-size-18">CMS List</h4>
              </div>
            </Col>
          </Row>
            <Row>
              <Col xs="12">
                <Card>
                <CardBody style={{
                    minHeight:"calc(100vh - 230px)"
                  }}>
                    {
                      isLoading ? <Spinners /> :
                    <TableContainer
                      columns={columns}
                      data={registrationData || []}
                      isGlobalFilter={true}
                      isCustomPageSize={true}
                      handleUserClick={handleOrderClicks}
                      isPagination={true}
                      SearchPlaceholder="26 records..."
                      buttonClass="btn btn-success btn-rounded waves-effect waves-light mb-2 me-2 addOrder-modal"
                      buttonName=" Add New Order"
                      tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                      theadClass="table-light"
                      pagination="pagination"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                    />}
                  </CardBody>
                </Card>
              </Col>
            </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  )
}

export default CMSList
